import script from "./AdminLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminLayout.vue?vue&type=script&lang=ts&setup=true"

import "./AdminLayout.vue?vue&type=style&index=0&id=2e55d20f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e55d20f"]])

export default __exports__